export default {"src":"/_next/static/media/SpaceIcon3Abyss.b58131ab.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};